/**
 * 行程推薦的分類加權（`recommendations.weights.manage` 權限）。
 *
 * 加權是加在推薦評分上的分數，不是百分比也不是排名——見 CMS 頁面的說明。
 */

import { apiFetch, type Schemas } from './core';

export type RecommendationWeight = Schemas['RecommendationWeightDto'];

/** 分類鍵與 products.category 對齊。 */
export type WeightMap = Record<'trip' | 'experience' | 'package' | 'charter', number>;

export function listRecommendationWeights(): Promise<RecommendationWeight[]> {
  return apiFetch<RecommendationWeight[]>('/admin/recommendation-weights', { method: 'GET' });
}

/** 四個分類一起送；後端在同一個 transaction 內完成，不會留下改了一半的狀態。 */
export function updateRecommendationWeights(weights: WeightMap): Promise<RecommendationWeight[]> {
  return apiFetch<RecommendationWeight[]>('/admin/recommendation-weights', {
    method: 'PUT',
    body: { weights },
  });
}
